import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FileCode2 } from 'lucide-react';

interface FileListProps {
    visibleFiles: Array<{ identity: string; displayName: string; createdAtMs: number; deletedAtMs?: number }>;
    selectedIdentity: string | undefined;
    onSelectFile: (identity: string) => void;
}

export default function FileList({ visibleFiles, selectedIdentity, onSelectFile }: FileListProps) {
    return (
        <Card className="col-span-3 flex flex-col">
            <CardHeader>
                <CardTitle className="text-sm flex items-center gap-2"><FileCode2 className="size-4" /> Files</CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
                <ScrollArea className="h-[58vh] pr-2">
                    <div className="flex flex-col gap-1">
                        {visibleFiles.length === 0 && (
                            <div className="text-sm text-muted-foreground px-2 py-1">No files</div>
                        )}
                        {visibleFiles.map((f) => (
                            <Button
                                key={f.identity}
                                variant={selectedIdentity === f.identity ? 'secondary' : 'ghost'}
                                className="justify-start"
                                onClick={() => onSelectFile(f.identity)}
                                title={f.displayName}
                            >
                                <span className="flex items-center gap-2">
                                    {f.displayName}
                                </span>
                            </Button>
                        ))}
                    </div>
                </ScrollArea>
            </CardContent>
        </Card>
    );
}
